import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';
import styles from './styles.scss';
import { joinClassNames } from '../../../../utils';

type PriorityLowIconProps = Omit<BaseIconProps, 'children'>;

export const PriorityLowIcon = ({ className, ...props }: PriorityLowIconProps) => (
  <BaseIcon
    hasLegacyStrokeStyles={false}
    width="17"
    height="17"
    viewBox="0 0 17 17"
    className={joinClassNames(styles.priorityLowIcon, className)}
    {...props}
  >
    <rect x="0.5" y="0.788086" width="16" height="16" rx="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.49997 12.7881C8.2032 12.7881 7.92175 12.6563 7.73175 12.4283L2.73175 6.42827C2.37819 6.00399 2.43551 5.37343 2.85979 5.01986C3.28407 4.6663 3.91463 4.72362 4.2682 5.1479L8.49997 10.226L12.7318 5.1479C13.0853 4.72362 13.7159 4.6663 14.1402 5.01986C14.5644 5.37343 14.6218 6.00399 14.2682 6.42827L9.2682 12.4283C9.0782 12.6563 8.79675 12.7881 8.49997 12.7881Z"
    />
  </BaseIcon>
);

PriorityLowIcon.displayName = 'PriorityLowIcon';
